import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 32.43 26.35",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32.43 26.35\" id=\"icon-folder\"><defs></defs><g id=\"icon-folder_Layer_2\" data-name=\"Layer 2\"><g id=\"icon-folder_Layer_1-2\" data-name=\"Layer 1\"><path d=\"M26.35,26.35l6.08-16.21H6.08L0,26.35ZM4.05,8.11,0,26.35V0H9.12l4.05,4.05H26.35V8.11Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol